import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from '../hooks/use-toast';
import { ArrowLeft } from 'lucide-react';

const NewClientPage = () => {
  const nav = useNavigate();
  const { addClient } = useApp();
  const [form, setForm] = React.useState({
    name: '', phone: '', email: '', city: '', pan_last4: '', kyc_status: 'pending'
  });

  const set = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast({ title: 'Name is required' }); return; }
    try {
      const c = await addClient(form);
      toast({ title: 'Client added', description: `${c.name} has been onboarded.` });
      nav(`/clients/${c.id}`);
    } catch (err) {
      toast({ title: 'Save failed', description: err?.apiMessage || 'Please try again' });
    }
  };

  return (
    <div className="p-6 md:p-8 max-w-3xl mx-auto">
      <button onClick={() => nav(-1)} className="text-xs text-brand-indigo font-semibold flex items-center gap-1 hover:underline mb-4"><ArrowLeft className="h-3 w-3" /> Back</button>
      <h1 className="text-3xl font-bold text-brand-indigo">New Client Onboarding</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-6">Capture basic client details. Full KYC to be completed separately as per AMFI norms.</p>

      <Card className="border-brand-border">
        <CardContent className="p-6">
          <form onSubmit={submit} className="grid md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <Label htmlFor="name">Full name *</Label>
              <Input id="name" value={form.name} onChange={(e) => set('name', e.target.value)} className="mt-1 h-11" placeholder="Ramesh Shah" />
            </div>
            <div>
              <Label htmlFor="phone">Phone</Label>
              <Input id="phone" value={form.phone} onChange={(e) => set('phone', e.target.value)} className="mt-1 h-11" placeholder="+91 98250 12345" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={form.email} onChange={(e) => set('email', e.target.value)} className="mt-1 h-11" placeholder="client@example.com" />
            </div>
            <div>
              <Label htmlFor="city">City</Label>
              <Input id="city" value={form.city} onChange={(e) => set('city', e.target.value)} className="mt-1 h-11" placeholder="Surat" />
            </div>
            <div>
              <Label htmlFor="pan">PAN (last 4)</Label>
              <Input id="pan" maxLength={4} value={form.pan_last4} onChange={(e) => set('pan_last4', e.target.value.toUpperCase())} className="mt-1 h-11" placeholder="XXXX" />
            </div>
            <div>
              <Label>KYC Status</Label>
              <Select value={form.kyc_status} onValueChange={(v) => set('kyc_status', v)}>
                <SelectTrigger className="mt-1 h-11"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">Pending</SelectItem>
                  <SelectItem value="verified">Verified</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="md:col-span-2 flex gap-3 pt-2">
              <Button type="button" variant="outline" onClick={() => nav(-1)}>Cancel</Button>
              <Button type="submit" className="bg-brand-indigo hover:bg-brand-indigoLight text-white">Add Client</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewClientPage;
